export default Object.freeze({
  Pending: 1,
  InProcess: 2,
  Finalized: 3,
  NotFinalized: 4,
});
